module.exports = "/assets/data/c279ea557cc632e9487554a062696f71-WR4.data.json";